if ( $('#projects').length ) {
  var targetPage;

  //- ajax load spinner
  $(document)
  .ajaxStart(function () {
    $('.projects-sorted article').addClass('loading');
    $('#map').addClass('loading');
  })
  .ajaxSuccess(function () {
    $('.projects-sorted article').removeClass('loading');
    $('#map').removeClass('loading');
  });
  //- first load
  $('.projects-sorted article').removeClass('loading');

  function initProjectsList() {
    $('.next').on('click', function(e) {
      e.preventDefault();
      targetPage = currentPage + 1;
    });
    $('.prev').on('click', function(e) {
      e.preventDefault();
      targetPage = currentPage - 1;
    });

    $('.page-numbers').on('click', function(e) {
      e.preventDefault();
      targetPage = targetPage || parseInt($(this).text());
      resetMarkers(currentPostsIds);
      resetMarkers(onlinePostsIds);
      getSelectedProjects(countries, regions, sectors, targetPage);
      $("html, body").animate({ scrollTop: $('#financed').offset().top }, 'slow');
      currentPage = targetPage;
      targetPage = null;
    });

    $('a.project-card[href="#"]').on('click', function(e){
        e.preventDefault();
    });

    //- highlights map's markers of the current page
    $('.highlight label').on('click', function(e){
      if( $('#current-page').is(':checked') ){
        setMarkersColor(currentPostsIds, iconDark, google.maps.Animation.BOUNCE);
      } else{
        resetMarkers(currentPostsIds);
      }
    });
  }

  $(function(){
    initProjectsList();
  })
}
